import dayjs from 'dayjs'
import { CampaignBudgetFormModel, TemporaryCampaignBudgetFormModel } from '.'
import { DateTimeFormat } from '../Constants'

/**
 * @typedef { { startTime: string, endTime: string }} Period
 * @typedef {Period[]} CampaignBudgets
 */

/**
 * @param {InsertionOrderBudgetFormModel} insertionOrderBudget
 * @param {CampaignBudgets} campaignBudgets
 * @param {*} param2
 * @property {number} param2.budget
 * @returns {CampaignBudgetFormModel | TemporaryCampaignBudgetFormModel}
 */
const factoryCampaignBudget = (
  insertionOrderBudget,
  campaignBudgets,
  { budget = 0 },
) => {
  const { startTime, endTime } = getEmptyPeriod(
    campaignBudgets,
    insertionOrderBudget.summary,
  )

  // 既に終了している案件予算はキャンペーン予算を作成しない
  if (dayjs().isAfter(dayjs(endTime).endOf('minute'))) return

  if (insertionOrderBudget.isApproved && !insertionOrderBudget.isWaiting) {
    return new CampaignBudgetFormModel({
      insertionOrderBudgetId: insertionOrderBudget.id,
      budget,
      startTime,
      endTime,
    })
  } else if (insertionOrderBudget.isWaiting) {
    return new TemporaryCampaignBudgetFormModel({
      insertionOrderBudgetRequestId: insertionOrderBudget.latestRequest.id,
      budget,
      startTime,
      endTime,
    })
  }
}

/**
 * 案件予算内のキャンペーン予算が設定されていない期間を取得する。
 * 空きがない場合、最終日を返す。
 *
 * @param {CampaignBudgets} campaignBudgets
 * @param {*} param1
 * @property {string} startTime
 * @property {string} endTime
 * @returns {Period}
 */
const getEmptyPeriod = (campaignBudgets, { startTime, endTime }) => {
  const untilTodayPeriod = getUntilTodayPeriod({ startTime, endTime })
  // 計算対象となるバジェットのみにし、先頭に当日までの期間を入れておく
  const budgetsForCalc = [
    untilTodayPeriod,
    ...campaignBudgets.filter(budget => !isPastBudget(budget)),
  ].filter(budget => budget != null)
  return budgetsForCalc.reduce(
    (acc, budget) => {
      if (dayjs(acc.startTime).isBefore(budget.startTime)) {
        const startTime = acc.startTime
        const endTime = dayjs(budget.startTime)
          .subtract(1, 'second')
          .format(DateTimeFormat)
        return { startTime, endTime }
      } else if (dayjs(acc.endTime).isSame(budget.endTime)) {
        const startTime = dayjs(budget.endTime)
          .startOf('day')
          .format(DateTimeFormat)
        const endTime = budget.endTime
        return { startTime, endTime }
      } else {
        const startTime = dayjs(budget.endTime)
          .add(1, 'second')
          .format(DateTimeFormat)
        const endTime = acc.endTime
        return { startTime, endTime }
      }
    },
    { startTime, endTime },
  )
}

const getUntilTodayPeriod = ({ startTime, endTime }) => {
  const today = dayjs().startOf('day')
  if (dayjs(endTime).isBefore(today)) {
    // 配信終了
    return { startTime, endTime }
  } else if (dayjs(startTime).isAfter(today)) {
    // 配信前
    return undefined
  } else {
    // 配信中
    return { startTime, endTime: today.endOf('day').format(DateTimeFormat) }
  }
}

const isPastBudget = budget => dayjs(budget.endTime).isBefore(dayjs())

export default factoryCampaignBudget
